<head>
  <title></title>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>

<div class="d-flex justify-content-between">
  <app-breadcrumb id="MainActivity" *ngIf="qmsService.refereshBreadCrumb"></app-breadcrumb>
  <div class="d-flex gap-4 align-items-center">
    <div class="">
      <span class="crDetail-status1" *ngIf="qmsService.activity != undefined"
        [ngStyle]="statusAppearance(qmsService.activity.status)">
        Status&nbsp;:&nbsp; <span>{{ qmsService.activity.status }}</span>
      </span>
    </div>
    <div class="d-flex gap-2">
      <div class="d-flex align-items-center justify-content-center communication_cta pointer"
        (click)="openExportPopup()" (keydown.enter)="openExportPopup()" matTooltip="Report">
        <img src="../../../assets/img/cr_module/pdf.svg" width="22px" height="20px" alt="" />
      </div>

      <div class="d-flex align-items-center justify-content-center communication_cta  pointer"
        matTooltip="Dependent of">
        <img src="../../../assets/img/qms_img/dependency.svg" width="14px" height="14px" alt=""
          (click)="openDependentsPopup()" (keydown.enter)="openDependentsPopup()" />
      </div>
      <div *ngIf="message.isTopicAdministrator">
        <div class="d-flex align-items-center justify-content-center communication_cta pointer"
          matTooltip="Communication">
          <img src="../../../assets/img/cr_module/communication.svg" width="14px" height="14px" alt=""
            (click)="openTopicPopup()" (keydown.enter)="openTopicPopup()" />
        </div>
      </div>
      <div class="d-flex align-items-center justify-content-center communication_cta communication-icon pointer"
        matTooltip="Tag to Home" (click)="openTag()" (keydown.enter)="openTag()">
        <img src="../../../assets/img/tags.png" width="17px" height="19px" alt="" />
      </div>
    </div>
  </div>
</div>

<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="d-flex mt-2 mb-2">
  <div class="" style="margin-right:auto;">
    <app-task-stage-statistics *ngIf="qmsService.refereshBreadCrumb"></app-task-stage-statistics>
  </div>
  <div class="" style="margin-right:1%;align-content:center;" *ngIf="showParallelWorkflowAddButton">
    <div matTooltip="Add Workflow" (click)="openAddWorkflow()" (keydown.enter)="openAddWorkflow()"
      style="border: 0.75px solid rgba(222, 235, 254, 0.8980392157); border-radius: 100px; width: 36px; height: 36px;"
      class="d-flex justify-content-center align-items-center actions_cta pointer">
      <a>
        <img title="Switch User" src="..//..//../assets/img/parallel workflow.svg" alt="parallel-workflow" width="20"
          height="20">
      </a>
    </div>
  </div>
  <div class="">
    <div class="">
      <app-activity-dynamic-button></app-activity-dynamic-button>
    </div>
  </div>
</div>

<div class="form-template">
  <div class="tab">
    <mat-tab-group mat-stretch-tabs class="activitytab mat-tab-container mat-elevation-z4" animationDuration="0ms"
      (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex" *ngIf="dynamicLabel" #tabsGroup>
      <mat-tab label="Customer Complaints">
        <ng-template mat-tab-label>
          <span>
            <i class="fa-solid fa-file-circle-exclamation" style="font-size: 20px;" aria-hidden="true"></i>
          </span>&nbsp;<span>{{qmsService.moduleFullName}}</span>
        </ng-template>
        <div>
          <fieldset class="border p-2 fieldsetStyle">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Complainant / Reporter Details</span>
            </legend>
            <div class="row">
              <div class="col-md-2">
                <div>
                  <!-- Complaint ID -->
                  <label for="cc-id">{{dynamicLabel['CC_ID']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['CC_ID']?.fieldNotes"
                    [matTooltip]="dynamicLabel['CC_ID'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="cc-id" class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.ccId" [matTooltip]="qmsService.activity.ccId" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Status -->
                  <label for="status">{{dynamicLabel['STATUS']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['STATUS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['STATUS']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="status" class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.status" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Initiated By -->
                  <label for="initiator">{{dynamicLabel['INITIATOR_USER']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['INITIATOR_USER']?.fieldNotes"
                    [matTooltip]="dynamicLabel['INITIATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="initiator" class="input-filed-continers disabled-input" type="text" id=""
                  [(ngModel)]="qmsService.activity.initiatorUser" disabled>
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['REPORTER_TITLE']?.isRemovable == 'Y'">
                <div>
                  <!-- Title -->
                  <label id="title-validation" for="title">{{dynamicLabel['REPORTER_TITLE']?.fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TITLE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_TITLE']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select id="title" matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddTitle == qmsService.ccDropDowns.selectedReporterTitle}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedReporterTitle" [disabled]="isComplainantSectionFrozen"
                  (closed)="titleSearchText=''" (click)="focusSearch('focus-title-search')"
                  (keydown.enter)="focusSearch('focus-title-search')">
                  <input type="search" id="focus-title-search" class="dropdownsearchstyle" [(ngModel)]="titleSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onReporterTitleSelect($event,null);">Un-select</mat-option>
                  <mat-option *ngFor="let item of reporterTitleDropDown | assessmentSearch : titleSearchText;"
                    (onSelectionChange)="onReporterTitleSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- First Name -->
                  <label id="first-name-validation"
                    for="first-name">{{dynamicLabel['REPORTER_FIRST_NAME']?.fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FIRST_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_FIRST_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="first-name" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_FIRST_NAME')"
                  [(ngModel)]="qmsService.activity.reporterFirstName"
                  (ngModelChange)="onNgModelChange($event,'first-name-validation')"
                  [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['REPORTER_MIDDLE_NAME']?.isRemovable == 'Y'">
                <div>
                  <!-- Middle Name -->
                  <label for="middle-name">{{dynamicLabel['REPORTER_MIDDLE_NAME']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_MIDDLE_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_MIDDLE_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="middle-name" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_MIDDLE_NAME')"
                  [(ngModel)]="qmsService.activity.reporterMiddleName" [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['REPORTER_LAST_NAME']?.isRemovable != 'Y'">
                <div>
                  <!-- Last Name -->
                  <label id="last-name-validation"
                    for="last-name">{{dynamicLabel['REPORTER_LAST_NAME']?.fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_LAST_NAME']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_LAST_NAME']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="last-name" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_LAST_NAME')"
                  [(ngModel)]="qmsService.activity.reporterLastName"
                  (ngModelChange)="onNgModelChange($event,'last-name-validation')"
                  [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['REPORTER_TYPE']?.isRemovable == 'Y'">
                <div>
                  <!-- Reporter Type -->
                  <label id="reporter-type-validation"
                    for="reporter-type">{{dynamicLabel['REPORTER_TYPE']?.fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_TYPE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_TYPE']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select id="reporter-type" matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddType == qmsService.ccDropDowns.selectedReporterType}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedReporterType" [disabled]="isComplainantSectionFrozen"
                  (closed)="reporterTypeSearchText=''" (click)="focusSearch('focus-reporter-type-search')"
                  (keydown.enter)="focusSearch('focus-reporter-type-search')">
                  <input type="search" id="focus-reporter-type-search" class="dropdownsearchstyle"
                    [(ngModel)]="reporterTypeSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onReporterTypeSelect($event,null);">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of reporterTypeDropDown | assessmentSearch : reporterTypeSearchText; let last = last;"
                    (onSelectionChange)="onReporterTypeSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['REPORTER_DESIGNATION']?.isRemovable == 'Y'">
                <div>
                  <!-- Reporter Designation -->
                  <label for="designation">
                    {{dynamicLabel['REPORTER_DESIGNATION']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_DESIGNATION']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_DESIGNATION']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="designation" class="input-filed-continers" type="text"
                  [(ngModel)]="qmsService.activity.reporterDesignation" [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Email -->
                  <label id="email-validation" for="email">{{dynamicLabel['EMAIL_ADDRESS']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['EMAIL_ADDRESS']?.fieldNotes"
                    [matTooltip]="dynamicLabel['EMAIL_ADDRESS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="email" class="input-filed-continers" style="width: 100%;" type="email"
                  (input)="limitCharacters($event, 'EMAIL_ADDRESS')" [(ngModel)]="qmsService.activity.emailAddress"
                  [matTooltip]="ccData.emailAddress" [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['REPORTER_FAX']?.isRemovable != 'Y'">
                <div>
                  <!-- Fax -->
                  <label for="reporter-fax">{{dynamicLabel['REPORTER_FAX']?.fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_FAX'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_FAX'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="reporter-fax" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_FAX')" [(ngModel)]="qmsService.activity.reporterFax"
                  [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Contact No -->
                  <label for="contact-no">
                    {{dynamicLabel['REPORTER_CONTACT_NUMBER']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="contact-no" class="input-filed-continers" type="number" min="0"
                  (input)="limitCharacters($event, 'REPORTER_CONTACT_NUMBER')" (keypress)="validateMobileNumber($event)"
                  [(ngModel)]="qmsService.activity.reporterContactNumber" [disabled]="isComplainantSectionFrozen">
              </div>
              <div *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.isRemovable != 'Y'" class="col-md-2">
                <div>
                  <!-- Office Contact No -->
                  <label for="contact-no-off">
                    {{dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CONTACT_NUMBER_OFFICE']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="contact-no-off" class="input-filed-continers" type="number" min="0"
                  (input)="limitCharacters($event, 'REPORTER_CONTACT_NUMBER_OFFICE')"
                  (keypress)="validateMobileNumber($event)"
                  [(ngModel)]="qmsService.activity.reporterContactNumberOffice" [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Address Field 1 -->
                  <label id="address-field1-validation" for="reporter-address-1">
                    {{dynamicLabel['REPORTER_ADDRESS1']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS1']?.fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ADDRESS1'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea id="reporter-address-1" type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="qmsService.activity.reporterAddress1"
                  (input)="limitCharacters($event, 'REPORTER_ADDRESS1')"
                  (ngModelChange)="onNgModelChange($event,'address-field1-validation')"
                  [disabled]="isComplainantSectionFrozen"></textarea>
              </div>
              <div class="col-md-4" *ngIf="dynamicLabel['REPORTER_ADDRESS2'].isRemovable !== 'Y'">
                <div>
                  <!-- Address Field 2 -->
                  <label id="address-field2-validation" for="reporter-address-2">
                    {{dynamicLabel['REPORTER_ADDRESS2'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ADDRESS2'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ADDRESS2'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <textarea id="reporter-address-2" type="text" class="input-filed-textarea" rows="4" cols="50"
                  [(ngModel)]="qmsService.activity.reporterAddress2"
                  (input)="limitCharacters($event, 'REPORTER_ADDRESS2')"
                  (ngModelChange)="onNgModelChange($event,'address-field2-validation')"
                  [disabled]="isComplainantSectionFrozen"></textarea>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- City -->
                  <label for="reporter-city">{{dynamicLabel['REPORTER_CITY'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_CITY'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_CITY'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="reporter-city" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_CITY')" [(ngModel)]="qmsService.activity.reporterCity"
                  [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2">
                <div>
                  <label for="reporter-state">{{dynamicLabel['REPORTER_STATE'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_STATE'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_STATE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <!-- State -->
                <input id="reporter-state" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_STATE')" [(ngModel)]="qmsService.activity.reporterState"
                  [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['REPORTER_COUNTRY']?.isRemovable != 'Y'">
                <div>
                  <!-- Country -->
                  <label for="reporter-country">{{dynamicLabel['REPORTER_COUNTRY'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COUNTRY'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_COUNTRY'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qmsService.ccDropDowns.selectedReporterCountry"
                  [ngClass]="{'odd-item-mat-select': oddCountry == qmsService.ccDropDowns.selectedReporterCountry}"
                  [disabled]="isComplainantSectionFrozen" (closed)="reporterCountrySearchText=''"
                  (click)="focusSearch('focus-country-search')" (keydown.enter)="focusSearch('focus-country-search')">
                  <input type="search" id="focus-country-search" class="dropdownsearchstyle"
                    [(ngModel)]="reporterCountrySearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" (onSelectionChange)="onCountrySelect($event,null)"
                    [value]="null">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of reporterCountryDropDown | assessmentSearch : reporterCountrySearchText"
                    [value]="item.valueExp" (onSelectionChange)="onCountrySelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Zip Code -->
                  <label for="reporter-zipcode">{{dynamicLabel['REPORTER_ZIPCODE'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_ZIPCODE'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_ZIPCODE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>

                </div>
                <input id="reporter-zipcode" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'REPORTER_ZIPCODE')"
                  [(ngModel)]="qmsService.activity.reporterZipcode" [disabled]="isComplainantSectionFrozen">
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Evaluator -->
                  <label for="evaluator">{{dynamicLabel['EVALUATOR_USER'].fieldName}}</label>
                  <label for="evaluator"
                    *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qmsService.activity.status,'evaluator')">
                    <a (click)="openSwitchUser('Evaluator')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['EVALUATOR_USER'].fieldNotes"
                    [matTooltip]="dynamicLabel['EVALUATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddEvaluator == qmsService.ccDropDowns.selectedEvaluator}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedEvaluator" [disabled]="isComplainantSectionFrozen"
                  (closed)="evaluatorSearchText=''" (click)="focusSearch('focus-evaluator-search')"
                  (keydown.enter)="focusSearch('focus-evaluator-search')">
                  <input type="search" id="focus-evaluator-search" class="dropdownsearchstyle"
                    [(ngModel)]="evaluatorSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of evaluatorDropDown | assessmentSearch : evaluatorSearchText"
                    [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.rejectReason">
                <div>
                  <!-- Evaluation Reject Reason -->
                  <label for="reject-reason">{{dynamicLabel['REJECT_REASON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['REJECT_REASON'].fieldNotes"
                    [matTooltip]="dynamicLabel['REJECT_REASON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="reject-reason" class="input-filed-continers disabled-input" type="text"
                  [(ngModel)]="qmsService.activity.rejectReason" [matTooltip]="qmsService.activity.rejectReason"
                  [disabled]="true">
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['IS_REIMBURSEMENT_REQD']?.isRemovable != 'Y'">
                <div>
                  <!-- Reimbursement Requested? -->
                  <label for="reimbursement-reqd">
                    {{dynamicLabel['IS_REIMBURSEMENT_REQD'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_REIMBURSEMENT_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['IS_REIMBURSEMENT_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="isReimbursementReqd"
                  [(ngModel)]="qmsService.activity.isReimbursementReqd"
                  (change)="onReimbursementRequestedChange($event)"
                  [disabled]="isComplainantSectionFrozen && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.isReimbursementReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['IS_REPONSE_REQUESTED_BY_CUSTOMER']?.isRemovable != 'Y'">
                <div>
                  <!-- Response Requested? -->
                  <label for="response-requested">
                    {{dynamicLabel['IS_REPONSE_REQUESTED_BY_CUSTOMER']?.fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_REPONSE_REQUESTED_BY_CUSTOMER']?.fieldNotes"
                    [matTooltip]="dynamicLabel['IS_REPONSE_REQUESTED_BY_CUSTOMER']?.fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.isReponseRequestedByCustomer"
                  (change)="onIsResponseRequestedByConsumerChange($event)"
                  [disabled]="isComplainantSectionFrozen  && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.isReponseRequestedByCustomer; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="qmsService.selectedGroupDetailData.isRiskCalculationReqd == 'Y'">
                <div>
                  <!-- Is Risk Calculation Reqd? -->
                  <label for="risk-reqd">
                    {{dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['IS_RISK_CALCULATION_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.isRiskCalculationReqd"
                  [disabled]="isComplainantSectionFrozen  && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.isRiskCalculationReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2 d-flex align-items-center justify-content-center" style="margin-top: -5%"
                *ngIf="qmsService.selectedGroupDetailData.isRiskCalculationReqd=='Y' && qmsService.activity.isRiskCalculationReqd && qmsService.activity.finalRiskScore">
                <div class="d-flex align-items-center gap-4">
                  <div class="qms-risk-icon" [matTooltip]="'Risk Status : ' + qmsService.activity.finalRiskStatus">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
                      stroke="#0f3659">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path d="M6.87988 18.1501V16.0801" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                        </path>
                        <path d="M12 18.15V14.01" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M17.1201 18.1499V11.9299" stroke="#0f3659" stroke-width="1.5" stroke-linecap="round">
                        </path>
                        <path d="M17.1199 5.8501L16.6599 6.3901C14.1099 9.3701 10.6899 11.4801 6.87988 12.4301"
                          stroke="#0f3659" stroke-width="1.5" stroke-linecap="round"></path>
                        <path d="M14.1899 5.8501H17.1199V8.7701" stroke="#0f3659" stroke-width="1.5"
                          stroke-linecap="round" stroke-linejoin="round">
                        </path>
                        <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
                          stroke="#0f3659" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                      </g>
                    </svg>
                  </div>

                  <div class="qms-risk-icon" [matTooltip]="'Navigate to Risk Assessment'" (click)="navigateToRisk()"
                    (keydown.enter)="navigateToRisk()">
                    <svg width="20" height="20" fill="#0f3659" viewBox="0 0 35 35" data-name="Layer 2" id="Layer_2"
                      xmlns="http://www.w3.org/2000/svg">
                      <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                      <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                      <g id="SVGRepo_iconCarrier">
                        <path
                          d="M21.81,34.75H21.5A3.8,3.8,0,0,1,18,31.58L16,20.12A1.36,1.36,0,0,0,14.88,19L3.42,17a3.84,3.84,0,0,1-.56-7.42L29.66.46h0a3.84,3.84,0,0,1,4.88,4.88l-9.11,26.8A3.79,3.79,0,0,1,21.81,34.75ZM30.47,2.83,3.66,11.94a1.34,1.34,0,0,0,.2,2.59l11.46,2a3.85,3.85,0,0,1,3.11,3.11l2,11.46a1.34,1.34,0,0,0,2.59.2L32.17,4.53a1.34,1.34,0,0,0-1.7-1.7Z">
                        </path>
                      </g>
                    </svg>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Reporter Comments -->
                  <label id="comments" for="reporter-comments">
                    {{dynamicLabel['REPORTER_COMMENTS'].fieldName}}
                  </label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTER_COMMENTS'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTER_COMMENTS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.reporterComments" [config]="config" [spellcheck]="true"
                      [disabled]="isComplainantSectionFrozen" (ngModelChange)="onStEditorChange($event, 'comments')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isComplainantSectionFrozen ? openEditor('Reporter Comments', 'eye') : openEditor('Reporter Comments', 'edit')"
                    (click)="isComplainantSectionFrozen ? openEditor('Reporter Comments', 'eye') : openEditor('Reporter Comments', 'edit')">
                    <i *ngIf="!isComplainantSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isComplainantSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Dates</span>
            </legend>
            <div class="row">
              <div class="col-md-2">
                <div>
                  <!-- Date of Occurrence -->
                  <label id="date-of-occurrence-validation"
                    for="occurrence-date">{{dynamicLabel['DATE_OF_OCCURRENCE'].fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DATE_OF_OCCURRENCE'].fieldNotes"
                    [matTooltip]="dynamicLabel['DATE_OF_OCCURRENCE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="occurrence-date" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="dateOfOccurrenceConfig" [dateCustomClasses]="dateCustomClasses"
                  (change)="onDateOfOccurrenceChange()" [(ngModel)]="qmsService.activity.dateOfOccurrence"
                  (ngModelChange)="onNgModelChange($event, 'date-of-occurrence-validation')"
                  [disabled]="isDateSectionFrozen">
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Date Reported -->
                  <label id="date-reported-validation"
                    for="date-reported">{{dynamicLabel['DATE_REPORTED'].fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['DATE_REPORTED'].fieldNotes"
                    [matTooltip]="dynamicLabel['DATE_REPORTED'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="date-reported" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="reportedDateConfig()" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.dateReported"
                  (ngModelChange)="onNgModelChange($event, 'date-reported-validation')"
                  [disabled]="!qmsService.activity.dateOfOccurrence || isDateSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.startedOn">
                <!-- Started On -->
                <div><label for="started-on ">{{dynamicLabel['STARTED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['STARTED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['STARTED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="started-on" type="text" class="form-control data-picker-continer disabled-input" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.startedOn" disabled>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Expected Closure Date -->
                  <label id="expected-closure-on-validation"
                    for="closure-on">{{dynamicLabel['EXPCETED_CLOSURE_ON'].fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['EXPCETED_CLOSURE_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="closure-on" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="expectedClosureConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.expcetedClosureOn"
                  (ngModelChange)="onNgModelChange($event, 'expected-closure-on-validation')"
                  [disabled]="isDateSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.completedOn">
                <div><label for="completed-on">{{dynamicLabel['COMPLETED_ON'].fieldName}}</label></div>
                <span class="info-icon" *ngIf="dynamicLabel['COMPLETED_ON'].fieldNotes"
                  [matTooltip]="dynamicLabel['COMPLETED_ON'].fieldNotes">
                  <img [src]="infoIconSrc" alt="note" width="18" height="18">
                </span>
                <input id="completed-on" type="text" class="form-control data-picker-continer disabled-input"
                  bsDatepicker [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.completedOn" disabled>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.groupReassignedOn">
                <div>
                  <!-- Group Reassigned On -->
                  <label for="group-reassigned">{{dynamicLabel['GROUP_REASSIGNED_ON'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['GROUP_REASSIGNED_ON'].fieldNotes"
                    [matTooltip]="dynamicLabel['GROUP_REASSIGNED_ON'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="group-reassigned" type="text" class="form-control data-picker-continer" bsDatepicker
                  [bsConfig]="dateTimeConfig" [dateCustomClasses]="dateCustomClasses"
                  [(ngModel)]="qmsService.activity.groupReassignedOn" disabled>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle" [hidden]="!message.showComplaintIdentificationSection">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Complaint Identification</span>
            </legend>
            <div class="row">
              <div class="col-md-2" *ngIf="dynamicLabel['NATURE_OF_COMPLAINT']?.isRemovable != 'Y'">
                <div>
                  <!-- Nature of Complaint -->
                  <label id="nature-of-complaint-validation"
                    for="nature-of-complaint">{{dynamicLabel['NATURE_OF_COMPLAINT'].fieldName}}</label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['NATURE_OF_COMPLAINT'].fieldNotes"
                    [matTooltip]="dynamicLabel['NATURE_OF_COMPLAINT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select" [(ngModel)]="qmsService.ccDropDowns.selectedNatureOfComplaint"
                  [ngClass]="{'odd-item-mat-select': oddNatureOfComplaint == qmsService.ccDropDowns.selectedNatureOfComplaint}"
                  [disabled]="isIdentificationSectionFrozen" (closed)="natureOfComplaintSearchText=''"
                  (click)="focusSearch('focus-nature-of-complaint-search')"
                  (keydown.enter)="focusSearch('focus-nature-of-complaint-search')">
                  <input type="search" id="focus-nature-of-complaint-search" class="dropdownsearchstyle"
                    [(ngModel)]="natureOfComplaintSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" (onSelectionChange)="onNatureOfComplaintSelect($event,null)"
                    [value]="null">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of natureOfComplaintDropDown | assessmentSearch : natureOfComplaintSearchText; let last = last;"
                    (onSelectionChange)="onNatureOfComplaintSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['LOCATION_DETAILS_NAME']?.isRemovable != 'Y'">
                <div>
                  <!-- Location -->
                  <label for="location-details">{{dynamicLabel['LOCATION_DETAILS_NAME'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['LOCATION_DETAILS_NAME'].fieldNotes"
                    [matTooltip]="dynamicLabel['LOCATION_DETAILS_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddLocation == qmsService.ccDropDowns.selectedLocations}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedLocations" [disabled]="isIdentificationSectionFrozen"
                  (closed)="locationSearchText=''" (click)="focusSearch('focus-location-search')"
                  (keydown.enter)="focusSearch('focus-location-search')">
                  <input type="search" id="focus-location-search" class="dropdownsearchstyle"
                    [(ngModel)]="locationSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" (onSelectionChange)="onLocationSelect($event,null)"
                    [value]="null">Un-select</mat-option>
                  <mat-option *ngFor="let item of locationsDropDown | assessmentSearch : locationSearchText"
                    (onSelectionChange)="onLocationSelect($event,item)" [value]="item.valueExp">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="showLocationIfOthers">
                <div>
                  <!-- Location if Others -->
                  <label for="location-others">
                    {{dynamicLabel['LOCATION_IF_OTHERS'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['LOCATION_IF_OTHERS'].fieldNotes"
                    [matTooltip]="dynamicLabel['LOCATION_IF_OTHERS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="location-others" class="input-filed-continers" type="text"
                  (input)="limitCharacters($event, 'LOCATION_IF_OTHERS')"
                  [(ngModel)]="qmsService.activity.locationIfOthers" [matTooltip]="qmsService.activity.locationIfOthers"
                  [disabled]="isIdentificationSectionFrozen">
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['DEPT_NAME']?.isRemovable != 'Y'">
                <div>
                  <!-- Department -->
                  <label for="dept-code">{{dynamicLabel['DEPT_NAME'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['DEPT_NAME'].fieldNotes"
                    [matTooltip]="dynamicLabel['DEPT_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput multiple placeholder="Select" #department
                  [(ngModel)]="qmsService.ccDropDowns.selectedDepartment" (closed)="departmentSearchText=''"
                  (click)="focusSearch('focus-department-search')"
                  (keydown.enter)="focusSearch('focus-department-search')"
                  [disabled]="!qmsService.ccDropDowns.selectedLocations || isIdentificationSectionFrozen">
                  <input type="search" id="focus-department-search" class="dropdownsearchstyle"
                    [(ngModel)]="departmentSearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="departmentSelection" (change)="toggleAllSelection('department')">
                      Select All</mat-checkbox>
                  </div>
                  <mat-option *ngFor="let item of departmentDropDown | multiAssessmentSearchPipe : departmentSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onDepartmentSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>

              <div class="col-md-2" *ngIf="dynamicLabel['REPORTED_COMPLAINT_TYPE']?.isRemovable != 'Y'">
                <div>
                  <!-- Initial Complaint Category -->
                  <label id="initial-complaint-category-validation" for="initial-complaint-category">
                    {{dynamicLabel['REPORTED_COMPLAINT_TYPE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['REPORTED_COMPLAINT_TYPE'].fieldNotes"
                    [matTooltip]="dynamicLabel['REPORTED_COMPLAINT_TYPE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                  <!-- Label as renamed for user convenience from Reported Complaint Type to Initial Complaint Category -->
                </div>
                <mat-select matInput multiple placeholder="Select" #initialComplaintCategory
                  [(ngModel)]="qmsService.ccDropDowns.selectedReportedComplaintType"
                  (closed)="initialCategorySearchText=''" (click)="focusSearch('focus-initial-category-search')"
                  (keydown.enter)="focusSearch('focus-initial-category-search')"
                  [disabled]="isIdentificationSectionFrozen">
                  <input type="search" id="focus-initial-category-search" class="dropdownsearchstyle"
                    [(ngModel)]="initialCategorySearchText" matInput placeholder="search">
                  <div class="select-all">
                    <mat-checkbox [(ngModel)]="initialComplaintCategorySelection"
                      (change)="toggleAllSelection('initialComplaintCategory')">
                      Select All</mat-checkbox>
                  </div>
                  <mat-option
                    *ngFor="let item of reportedComplaintTypeDropDown | multiAssessmentSearchPipe : initialCategorySearchText"
                    [value]="item.valueExp" (onSelectionChange)="onReportedComplaintTypeSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" *ngIf="dynamicLabel['SOURCE_OF_COMPLAINT']?.isRemovable != 'Y'">
                <div>
                  <!-- Source of Complaint -->
                  <label id="source-of-complaint-validation" for="source-of-complaint">
                    {{dynamicLabel['SOURCE_OF_COMPLAINT'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['SOURCE_OF_COMPLAINT'].fieldNotes"
                    [matTooltip]="dynamicLabel['SOURCE_OF_COMPLAINT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddSourceOfComplaint == qmsService.ccDropDowns.selectedSourceOfComplaint}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedSourceOfComplaint"
                  [disabled]="isIdentificationSectionFrozen" (closed)="sourceOfComplaintSearchText=''"
                  (click)="focusSearch('focus-source-of-complaint-search')"
                  (keydown.enter)="focusSearch('focus-source-of-complaint-search')">
                  <input type="search" id="focus-source-of-complaint-search" class="dropdownsearchstyle"
                    [(ngModel)]="sourceOfComplaintSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onSourceOfComplaintSelect($event,null)">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of sourceOfComplaintDropDown | assessmentSearch : sourceOfComplaintSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onSourceOfComplaintSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-2" id="search-container" [hidden]="this.qmsService.activity.qaUser==0">
                <!-- QA User  -->
                <div>
                  <label id="qa-user-validation" for="qa-user">
                    {{dynamicLabel['QA_USER_NAME'].fieldName}}
                    <span class="mandatory-symbol">*</span>
                  </label>
                  <label *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qmsService.activity.status,'qa')"
                    id="owner-validation" for="email">
                    <a (click)="openSwitchUser('QA')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['QA_USER_NAME'].fieldNotes"
                    [matTooltip]="dynamicLabel['QA_USER_NAME'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddQA == qmsService.ccDropDowns.selectedQA}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedQA"
                  [disabled]="isIdentificationSectionFrozen || qmsService.activity.status == 'Investigator Requested More Information'"
                  (closed)="qaSearchText=''" (click)="focusSearch('focus-qa-search')"
                  (keydown.enter)="focusSearch('focus-qa-search')">
                  <input type="search" id="focus-qa-search" class="dropdownsearchstyle" [(ngModel)]="qaSearchText"
                    matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onQaUserSelect($event,null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of qaDropdown | assessmentSearch : qaSearchText" [value]="item.valueExp"
                    (onSelectionChange)="onQaUserSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Complaint Description -->
                  <label id="complaint-description-validation" for="complaint-description">
                    {{dynamicLabel['COMPLAINT_DESCRIPTION'].fieldName}}
                  </label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['COMPLAINT_DESCRIPTION'].fieldNotes"
                    [matTooltip]="dynamicLabel['COMPLAINT_DESCRIPTION'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.complaintDescription" [config]="config"
                      [spellcheck]="true" [disabled]="isIdentificationSectionFrozen"
                      (ngModelChange)="onStEditorChange($event, 'complaint-description-validation')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isIdentificationSectionFrozen ? openEditor('Complaint Description', 'eye') : openEditor('Complaint Description', 'edit')"
                    (click)="isIdentificationSectionFrozen ? openEditor('Complaint Description', 'eye') : openEditor('Complaint Description', 'edit')">
                    <i *ngIf="!isIdentificationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isIdentificationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Initial Assessment -->
                  <label id="initial-assessment-validation" for="initial-assessment">
                    {{dynamicLabel['INITIAL_ASSESSMENT'].fieldName}}
                  </label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INITIAL_ASSESSMENT'].fieldNotes"
                    [matTooltip]="dynamicLabel['INITIAL_ASSESSMENT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.initialAssessment" [config]="config" [spellcheck]="true"
                      [disabled]="isIdentificationSectionFrozen"
                      (ngModelChange)="onStEditorChange($event, 'initial-assessment-validation')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isIdentificationSectionFrozen ? openEditor('Initial Assessment', 'eye') : openEditor('Initial Assessment', 'edit')"
                    (click)="isIdentificationSectionFrozen ? openEditor('Initial Assessment', 'eye') : openEditor('Initial Assessment', 'edit')">
                    <i *ngIf="!isIdentificationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isIdentificationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-2">
                <div>
                  <!-- Is Product Complaint? -->
                  <label for="product-complaint">
                    {{dynamicLabel['IS_PRODUCT_COMPLAINT'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_PRODUCT_COMPLAINT'].fieldNotes"
                    [matTooltip]="dynamicLabel['IS_PRODUCT_COMPLAINT'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="isProductComplaint"
                  [(ngModel)]="qmsService.activity.isProductComplaint" (change)="onIsProductComplaintChange($event)"
                  [disabled]="isIdentificationSectionFrozen && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.isProductComplaint; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" [hidden]="!qmsService.activity.isProductComplaint">
                <div>
                  <!-- Initial Company Complaint Type -->
                  <label id="initial-company-complaint-type-validation" for="initial-company-complaint-type">
                    {{dynamicLabel['COMPANY_COMPLAINT_TYPE'].fieldName}}
                  </label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['COMPANY_COMPLAINT_TYPE'].fieldNotes"
                    [matTooltip]="dynamicLabel['COMPANY_COMPLAINT_TYPE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                  <!-- Label as renamed for user convenience from Company Complaint Type to Initial Company Complaint Type -->
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddInitialComplaintType == qmsService.ccDropDowns.selectedCompanyComplaintType}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedCompanyComplaintType"
                  [disabled]="isIdentificationSectionFrozen && !elite_toggle"
                  (closed)="companyComplaintTypeSearchText=''" (click)="focusSearch('focus-company-complaint-search')"
                  (keydown.enter)="focusSearch('focus-company-complaint-search')">
                  <input type="search" id="focus-company-complaint-search" class="dropdownsearchstyle"
                    [(ngModel)]="companyComplaintTypeSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onCompanyComplaintTypeSelect($event,null)">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of companyComplaintTypeDropDown | assessmentSearch : companyComplaintTypeSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onCompanyComplaintTypeSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4"
                [hidden]="!qmsService.activity.isProductComplaint || dynamicLabel['IMMEDIATE_ACTION_TAKEN'].isRemovable == 'Y'">
                <div>
                  <!-- Immediate Action Taken -->
                  <label for="immediate-action-taken">
                    {{dynamicLabel['IMMEDIATE_ACTION_TAKEN'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IMMEDIATE_ACTION_TAKEN'].fieldNotes"
                    [matTooltip]="dynamicLabel['IMMEDIATE_ACTION_TAKEN'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.immediateActionTaken" [config]="config"
                      [spellcheck]="true" [disabled]="isIdentificationSectionFrozen && !elite_toggle"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isIdentificationSectionFrozen ? openEditor('Immediate Action Taken', 'eye') : openEditor('Immediate Action Taken', 'edit')"
                    (click)="isIdentificationSectionFrozen ? openEditor('Immediate Action Taken', 'eye') : openEditor('Immediate Action Taken', 'edit')">
                    <i *ngIf="!isIdentificationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isIdentificationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-2" *ngIf="qmsService.selectedGroupDetailData.preliminaryActionEnabled == 'Y'">
                <div>
                  <label for="email ">
                    {{dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldName}}
                  </label>
                  <span style="float:right" *ngIf="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes"
                    [matTooltip]="dynamicLabel['PRE_ACTION_ITEMS_REQD']?.fieldNotes">
                    <img [src]="qmsService.noteIcon" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.preActionItemsReqd"
                  [disabled]="isIdentificationSectionFrozen && !elite_toggle">
                  <span class="active-inActive-container"
                    [ngStyle]="{ color: qmsService.activity.preActionItemsReqd ? 'green' : 'red' }">
                    {{ qmsService.activity.preActionItemsReqd ? 'Yes' : 'No' }}
                  </span>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2"
                *ngIf="qmsService.activity.status != 'Draft' && qmsService.activity.status != 'Deleted' && qmsService.activity.status != 'Raised'">
                <div>
                  <!-- Is Action Required? -->
                  <label for="action-items">{{dynamicLabel['ACTION_ITEMS_REQD'].fieldName}}</label>
                  <span class="info-icon" *ngIf="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="actionItemsReqd"
                  [(ngModel)]="qmsService.activity.actionItemsReqd"
                  [disabled]="isIdentificationSectionFrozen && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.actionItemsReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.isProductComplaint">
                <div>
                  <!-- Is Investigation Required? -->
                  <label for="investigation-reqd">
                    {{dynamicLabel['IS_INVESTIGATION_REQD'].fieldName}}
                  </label>
                  <span class="info-icon" *ngIf="dynamicLabel['IS_INVESTIGATION_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['IS_INVESTIGATION_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-slide-toggle color="primary" name="isProductComplaint"
                  [(ngModel)]="qmsService.activity.isInvestigationReqd"
                  (change)="onIsInvestigationRequiredChange($event)"
                  [disabled]="isIdentificationSectionFrozen  && !elite_toggle">
                  <ng-container *ngIf="qmsService.activity.isInvestigationReqd; else no">
                    <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                  </ng-container>
                  <ng-template #no>
                    <span style="color: red;">No</span>
                  </ng-template>
                </mat-slide-toggle>
              </div>
              <div class="col-md-2" [hidden]="!qmsService.activity.isInvestigationReqd">
                <div>
                  <!-- Investigator -->
                  <label id="investigator-validation" for="investigator">
                    {{dynamicLabel['INVESTIGATOR_USER'].fieldName}}
                  </label>
                  <label for="email"
                    *ngIf="message.showSwitchUser && setSwitchUserAesthetic(qmsService.activity.status,'iu')">
                    <a (click)="openSwitchUser('Investigator')">
                      <img title="Switch User" src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                        height="25">
                    </a>
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATOR_USER'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATOR_USER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddInvestigator == qmsService.ccDropDowns.selectedInvestigator}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedInvestigator"
                  [disabled]="isIdentificationSectionFrozen && !elite_Investigation && !elite_toggle"
                  (closed)="investigatorSearchText=''" (click)="focusSearch('focus-investigator-search')"
                  (keydown.enter)="focusSearch('focus-investigator-search')">
                  <input type="search" id="focus-investigator-search" class="dropdownsearchstyle"
                    [(ngModel)]="investigatorSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onInvestigatorSelect($event,null)">Un-select</mat-option>
                  <mat-option *ngFor="let item of investigatorDropDown | assessmentSearch : investigatorSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onInvestigatorSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </fieldset>

          <fieldset class="border p-2 fieldsetStyle" [hidden]="!message.showInvestigationSection">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">Investigation</span>
            </legend>
            <div class="row">
              <div class="col-md-2" [hidden]="dynamicLabel['INVESTIGATION_REFERENCE_NUMBER'].isRemovable == 'Y'">
                <div>
                  <!-- Investigation Reference No -->
                  <label id="investigation-ref-no-validation" for="investigation-ref-no">
                    {{dynamicLabel['INVESTIGATION_REFERENCE_NUMBER'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_REFERENCE_NUMBER'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_REFERENCE_NUMBER'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <input id="investigation-ref-no" class="input-filed-continers" type="text"
                  [(ngModel)]="qmsService.activity.investigationReferenceNumber"
                  (ngModelChange)="onNgModelChange($event,'investigation-ref-no-validation')"
                  [disabled]="isInvestigationSectionFrozen">
              </div>
              <div class="col-md-4" [hidden]="dynamicLabel['INVESTIGATION_PLAN'].isRemovable == 'Y'">
                <div>
                  <!-- Investigation Plan -->
                  <label id="investigation-plan-validation" for="investigation-plan">
                    {{dynamicLabel['INVESTIGATION_PLAN'].fieldName}}
                  </label>
                  <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes"
                    [matTooltip]="dynamicLabel['ACTION_ITEMS_REQD'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.investigationPlan" [config]="config" [spellcheck]="true"
                      [disabled]="isInvestigationSectionFrozen"
                      (ngModelChange)="dynamicLabel['INVESTIGATION_PLAN'].isRemovable != 'Y' ? onStEditorChange($event, 'investigation-plan-validation') : null"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Investigation Plan', 'eye') : openEditor('Investigation Plan', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Investigation Plan', 'eye') : openEditor('Investigation Plan', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div>
                  <!-- Investigation Details -->
                  <label id="investigation-details-validation" for="investigation-details">
                    {{dynamicLabel['INVESTIGATION_DETAILS'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_DETAILS'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_DETAILS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.investigationDetails" [config]="config"
                      [spellcheck]="true" [disabled]="isInvestigationSectionFrozen"
                      (ngModelChange)="onStEditorChange($event, 'investigation-details-validation')"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Investigation Details', 'eye') : openEditor('Investigation Details', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Investigation Details', 'eye') : openEditor('Investigation Details', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
              <div class="col-md-2" [hidden]="dynamicLabel['INVESTIGATION_TECHNIQUE'].isRemovable == 'Y'">
                <div>
                  <!-- Investigation Technique -->
                  <label id="investigation-technique-validation" for="investigation-technique">
                    {{dynamicLabel['INVESTIGATION_TECHNIQUE'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_TECHNIQUE'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_TECHNIQUE'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <mat-select matInput placeholder="Select"
                  [ngClass]="{'odd-item-mat-select': oddInvestigationTechnique == qmsService.ccDropDowns.selectedInvestigationTechnique}"
                  [(ngModel)]="qmsService.ccDropDowns.selectedInvestigationTechnique"
                  [disabled]="isInvestigationSectionFrozen" (closed)="investigatorTechniqueSearchText=''"
                  (keydown.enter)="focusSearch('focus-investigator-technique-search')"
                  (click)="focusSearch('focus-investigator-technique-search')">
                  <input type="search" id="focus-investigator-technique-search" class="dropdownsearchstyle"
                    [(ngModel)]="investigatorTechniqueSearchText" matInput placeholder="search">
                  <mat-option class="unselectStyle" [value]="null"
                    (onSelectionChange)="onInvestigationTechniqueSelect($event,null)">Un-select</mat-option>
                  <mat-option
                    *ngFor="let item of investigationTechniqueDropDown | assessmentSearch : investigatorTechniqueSearchText"
                    [value]="item.valueExp" (onSelectionChange)="onInvestigationTechniqueSelect($event,item)">
                    {{ item.displayExp }}
                  </mat-option>
                </mat-select>
              </div>
              <div class="col-md-4"
                [hidden]="!showInvestigationIfOthers || dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].isRemovable == 'Y'">
                <div>
                  <!-- Investigation Technique if Others -->
                  <label id="investigation-technique-if-others-validation" for="investigation-technique-if-others">
                    {{dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].fieldName}}
                  </label> <span class="mandatory-symbol">*</span>
                  <span class="info-icon" *ngIf="dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].fieldNotes"
                    [matTooltip]="dynamicLabel['INVESTIGATION_TECHNIQUE_IF_OTHERS'].fieldNotes">
                    <img [src]="infoIconSrc" alt="note" width="18" height="18">
                  </span>
                </div>
                <div class="row">
                  <div class="hideToolbar col-sm-11">
                    <st-editor [(ngModel)]="qmsService.activity.investigationTechniqueIfOthers"
                      (ngModelChange)="onNgModelChange($event,'investigation-technique-if-others-validation')"
                      [config]="config" [spellcheck]="true" [disabled]="isInvestigationSectionFrozen"
                      (paste)="onPaste($event)"></st-editor>
                  </div>
                  <div class="col-sm-1 angular-editor-edit"
                    (keydown.enter)="isInvestigationSectionFrozen ? openEditor('Investigation Technique if Others', 'eye') : openEditor('Investigation Technique if Others', 'edit')"
                    (click)="isInvestigationSectionFrozen ? openEditor('Investigation Technique if Others', 'eye') : openEditor('Investigation Technique if Others', 'edit')">
                    <i *ngIf="!isInvestigationSectionFrozen" class="far fa-edit"></i>
                    <i *ngIf="isInvestigationSectionFrozen" class="fa fa-eye eye"></i>
                  </div>
                </div>
              </div>
            </div>
          </fieldset>
          <fieldset class="border p-2 crFieldsetStyle">
            <legend class="float-none w-auto p-2">
              <span class="" style="font-size: 14px;color: #cfcfcf;">More Info</span>
            </legend>
            <div class="row field-styles1" style="margin-top: -1%;">
              <div class="col-md-2" *ngIf="qmsService.activity.lastActionOn">
                <div>
                  <label for="email">
                    {{dynamicLabel['LAST_ACTION_ON']?.fieldName}}
                  </label>
                </div>
                <input type="text" class="form-control data-picker-continer" bsDatepicker [bsConfig]="dateTimeConfig"
                  [dateCustomClasses]="dateCustomClasses" [(ngModel)]="qmsService.activity.lastActionOn"
                  [disabled]="true">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.lastActionByUser">
                <div>
                  <label for="email">
                    {{dynamicLabel['LAST_ACTION_BY_USER']?.fieldName}}
                  </label>
                </div>
                <input type="text" class="input-filed-continers" [(ngModel)]="qmsService.activity.lastActionByUser"
                  [disabled]="true">
              </div>
              <div class="col-md-2" *ngIf="qmsService.activity.lastActionComments">
                <div>
                  <label for="email">
                    {{dynamicLabel['LAST_ACTION_COMMENTS']?.fieldName}}
                  </label>
                </div>
                <input type="text" class="input-filed-continers" [(ngModel)]="qmsService.activity.lastActionComments"
                  [disabled]="true">
              </div>
            </div>
          </fieldset>
        </div>
        <div class="ActivityPage" *ngIf="qmsService.refereshBreadCrumb">
          <app-flexible-fields #flexible [from]="'Details'"></app-flexible-fields>
        </div>

      </mat-tab>
      <div *ngFor="let tabPage of message.tabPagesOrderlist; let idx = index;">
        <mat-tab label="Documents" *ngIf="message.showDocumentSection  && tabPage=='Files'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.2501 1.80005V4.50005C11.2501 4.99711 11.6531 5.40005 12.1501 5.40005H14.8501M6.30014 5.40005H8.10014M6.30014 8.10005H11.7001M6.30014 10.8H11.7001M13.5001 3.15005C13.0996 2.79165 12.6839 2.36658 12.4215 2.09051C12.2469 1.9068 12.0057 1.80005 11.7522 1.80005H4.94993C3.95582 1.80005 3.14993 2.60593 3.14993 3.60004L3.14986 14.4C3.14985 15.3941 3.95573 16.2 4.94985 16.2L13.0499 16.2C14.044 16.2 14.8499 15.3942 14.8499 14.4001L14.8501 4.85842C14.8501 4.62829 14.7623 4.40708 14.6026 4.2414C14.3073 3.93503 13.8141 3.43094 13.5001 3.15005Z"
                  stroke="#005C8A" [ngStyle]="{strokeWidth: selectedTab == 'Documents' ? '2' : ''}"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>&nbsp;
            <span>Files</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Documents" style="margin-top:1%;">
            <app-task-documents (valueChange)="on_documents_emit($event)" *ngIf="selectedTab === 'Documents'"
              [activity]="this.objForDocuments"></app-task-documents>
          </div>
        </mat-tab>

        <mat-tab label="Risk Assessment" *ngIf="message.showRiskTab  && tabPage=='Risk Assessment'">
          <ng-template mat-tab-label>
            <span>
              <img src="../../assets/img/warning (1).png" alt="tasks" width="20" height="20" class="ng-star-inserted">
            </span>&nbsp;
            <span>Risk Assessment</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Risk Assesment" style="margin-top:1%;">
            <app-risk [pagename]="'activity'" *ngIf="selectedTab === 'Risk Assessment'"
              [isRiskFieldsActivited]="true"></app-risk>
          </div>
        </mat-tab>

        <mat-tab label="Products" *ngIf="message.showProductsTab  && tabPage=='Products'">
          <ng-template mat-tab-label>
            <span>
              <i class='fa-solid fa-capsules' style="font-size: 17px;" aria-hidden="true"></i>
            </span>&nbsp;
            <span>Products</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Actions" style="margin-top:1%;">
            <app-ccp (valueChange)="on_products_emit($event)" *ngIf="selectedTab =='Products'"></app-ccp>
          </div>
        </mat-tab>

        <mat-tab label="Preliminary Actions" *ngIf="message.showPreActionsTab && tabPage=='Preliminary Actions'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="1.8" cy="10" r="1.5" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : '1.2'}" />
                <path d="M4.2 9H6.6L8.3 4.5L10.8 13.5L12 9H15.5" stroke="#0F3659" stroke-linecap="round"
                  stroke-linejoin="round" [ngStyle]="{strokeWidth: selectedTab == 'Preliminary Actions' ? '2' : ''}" />
              </svg> &nbsp;
              <span>Preliminary Actions</span>
            </span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-pre-actions *ngIf="selectedTab === 'Preliminary Actions'" [activityData]=" true"></app-pre-actions>
          </div>
        </mat-tab>

        <mat-tab label="Actions" *ngIf="message.showActionSection  && tabPage=='Actions'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M2 8.99947H5.6L7.4364 3L11.3944 15.6L12.7913 8.99947H16.4" stroke="#0F3659"
                  stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'Actions' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>Actions</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-actions *ngIf="selectedTab === 'Actions'" (valueChange)="on_action_emit($event)"
              [activityData]="true"></app-actions>
          </div>
        </mat-tab>

        <mat-tab label="Workflow" *ngIf="parallelWorkflowList.length>0  && tabPage=='Parallel Workflow'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                  fill="#0F3659" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
              </svg> </span>&nbsp;
            <span>Parallel Workflow</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Workflow" style="margin-top:1%;">
            <app-parallel-workflow *ngIf="selectedTab === 'Workflow'" [showGrid]="true"></app-parallel-workflow>
          </div>
        </mat-tab>

        <mat-tab label="Reviewer/Approver"
          *ngIf="message.showReviewApproveSection && !isStageUsersSkipped  && tabPage=='Reviewer/Approver'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.72486 16.2H4.12485C3.13074 16.2 2.32485 15.3941 2.32486 14.4L2.32493 3.60004C2.32494 2.60593 3.13082 1.80005 4.12493 1.80005H12.2251C13.2192 1.80005 14.0251 2.60594 14.0251 3.60005V8.55005M10.4251 13.65L12.0751 15.3L15.6751 11.6999M5.47514 5.40005H10.8751M5.47514 8.10005H10.8751M5.47514 10.8H8.17514"
                  stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'Reviewer/Approver' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>Reviewer/Approver</span>
          </ng-template>
          <div class="form-template ActivityPage" id="ReviewApprove" style="margin-top:1%;">
            <app-stageusers [activityData]="this.qmsService.activity"
              (valueChange)="on_stageUser_emit($event)"></app-stageusers>
          </div>
        </mat-tab>

        <mat-tab label="Extension" *ngIf="message.showExtensionSection && tabPage=='Extension'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.3272 2.32701L11.6808 1.97346V1.97346L11.3272 2.32701ZM13.8728 4.8726L13.5192 5.22615L13.8728 4.8726ZM7.44645 12.3534C7.64172 12.5486 7.9583 12.5486 8.15356 12.3534C8.34882 12.1581 8.34882 11.8415 8.15356 11.6462L7.44645 12.3534ZM6.30001 10.4998L5.94645 10.1462C5.85268 10.24 5.80001 10.3672 5.80001 10.4998C5.80001 10.6324 5.85268 10.7596 5.94645 10.8534L6.30001 10.4998ZM8.15356 9.35336C8.34882 9.15809 8.34882 8.84151 8.15356 8.64625C7.9583 8.45099 7.64172 8.45099 7.44645 8.64625L8.15356 9.35336ZM10.5536 8.64625C10.3583 8.45099 10.0417 8.45099 9.84645 8.64625C9.65119 8.84151 9.65119 9.15809 9.84645 9.35336L10.5536 8.64625ZM11.7 10.4998L12.0536 10.8534C12.2488 10.6581 12.2488 10.3415 12.0536 10.1462L11.7 10.4998ZM9.84645 11.6463C9.65119 11.8415 9.65119 12.1581 9.84645 12.3534C10.0417 12.5486 10.3583 12.5486 10.5536 12.3534L9.84645 11.6463ZM12.6 15.6998H5.40001V16.6998H12.6V15.6998ZM4.10001 14.3998V3.5998H3.10001V14.3998H4.10001ZM5.40001 2.2998H10.0544V1.2998H5.40001V2.2998ZM13.9 6.14539V14.3998H14.9V6.14539H13.9ZM10.0544 2.2998C10.3992 2.2998 10.7299 2.43677 10.9737 2.68057L11.6808 1.97346C11.2494 1.54213 10.6644 1.2998 10.0544 1.2998V2.2998ZM5.40001 15.6998C4.68204 15.6998 4.10001 15.1178 4.10001 14.3998H3.10001C3.10001 15.6701 4.12975 16.6998 5.40001 16.6998V15.6998ZM12.6 16.6998C13.8703 16.6998 14.9 15.6701 14.9 14.3998H13.9C13.9 15.1178 13.318 15.6998 12.6 15.6998V16.6998ZM13.5192 5.22615C13.763 5.46995 13.9 5.80061 13.9 6.14539H14.9C14.9 5.53539 14.6577 4.95038 14.2264 4.51904L13.5192 5.22615ZM4.10001 3.5998C4.10001 2.88183 4.68204 2.2998 5.40001 2.2998V1.2998C4.12975 1.2998 3.10001 2.32955 3.10001 3.5998H4.10001ZM9.40001 1.7998V5.3998H10.4V1.7998H9.40001ZM10.8 6.7998H14.4V5.7998H10.8V6.7998ZM9.40001 5.3998C9.40001 6.173 10.0268 6.7998 10.8 6.7998V5.7998C10.5791 5.7998 10.4 5.62072 10.4 5.3998H9.40001ZM10.9737 2.68057L13.5192 5.22615L14.2264 4.51904L11.6808 1.97346L10.9737 2.68057ZM8.15356 11.6462L6.65356 10.1462L5.94645 10.8534L7.44645 12.3534L8.15356 11.6462ZM6.65356 10.8534L8.15356 9.35336L7.44645 8.64625L5.94645 10.1462L6.65356 10.8534ZM9.84645 9.35336L11.3465 10.8534L12.0536 10.1462L10.5536 8.64625L9.84645 9.35336ZM11.3465 10.1462L9.84645 11.6463L10.5536 12.3534L12.0536 10.8534L11.3465 10.1462Z"
                  fill="#0F3659" stroke="#0F3659"
                  [ngStyle]="{strokeWidth: selectedTab == 'Extension' ? '0.65' : '0.25'}" />
              </svg>
            </span>&nbsp;
            <span>Extension</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Extendsion" style="margin-top:1%;">
            <app-task-extensions [activityData]="true" (extension)="on_extension_emit($event)"
              *ngIf="selectedTab === 'Extension'"></app-task-extensions>
          </div>
        </mat-tab>

        <ng-container *ngIf="message.showFinalEvaluationTab && tabPage === 'Final Evaluation'">
          <mat-tab label="Final Evaluation">
            <ng-template mat-tab-label>
              <span>
                <i class='far fa-check-square' style="font-size: 17px;" aria-hidden="true"></i>
              </span>&nbsp;
              <span>Final Evaluation</span>
            </ng-template>
            <div class="form-template ActivityPage" style="margin-top:1%;">
              <fieldset class="border p-2 fieldsetStyle">
                <legend class="float-none w-auto p-2">
                  <span class="" style="font-size: 14px;color: #cfcfcf;">Final Evaluation</span>
                </legend>
                <div class="row">
                  <div class="col-md-4">
                    <div>
                      <!-- Complaint Accepted / Justification -->
                      <label id="complaint-accepted-validation" for="email">
                        {{dynamicLabel['COMPLAINT_ACCEPTED_OR_JUSTIFICATION'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['COMPLAINT_ACCEPTED_OR_JUSTIFICATION'].fieldNotes"
                        [matTooltip]="dynamicLabel['COMPLAINT_ACCEPTED_OR_JUSTIFICATION'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
                      [(ngModel)]="qmsService.activity.complaintAcceptedOrJustification"
                      (ngModelChange)="onNgModelChange($event,'complaint-accepted-validation')"
                      [disabled]="isFinalEvalSectionFrozen"></textarea>
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Is Market Action Required? -->
                      <label for="market-action-reqd">{{dynamicLabel['IS_MARKET_ACTION_REQD'].fieldName}}</label>
                      <span class="info-icon" *ngIf="dynamicLabel['IS_MARKET_ACTION_REQD'].fieldNotes"
                        [matTooltip]="dynamicLabel['IS_MARKET_ACTION_REQD'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-slide-toggle color="primary" name="isMarketActionReqd"
                      [(ngModel)]="qmsService.activity.isMarketActionReqd"
                      (change)="onIsMarketActionRequiredChange($event)" [disabled]="isFinalEvalSectionFrozen">
                      <ng-container *ngIf="qmsService.activity.isMarketActionReqd; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                      </ng-container>
                      <ng-template #no>
                        <span style="color: red;">No</span>
                      </ng-template>
                    </mat-slide-toggle>
                  </div>
                  <div class="col-md-2" [hidden]="!qmsService.activity.isMarketActionReqd">
                    <div>
                      <!-- Market Action -->
                      <label id="market-action-validation" for="market-action">
                        {{dynamicLabel['MARKET_ACTION_REQD'].fieldName}}
                      </label>
                      <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['MARKET_ACTION_REQD'].fieldNotes"
                        [matTooltip]="dynamicLabel['MARKET_ACTION_REQD'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select"
                      [ngClass]="{'odd-item-mat-select': oddMarketAction == qmsService.ccDropDowns.selectedMarketAction}"
                      [(ngModel)]="qmsService.ccDropDowns.selectedMarketAction" [disabled]="isFinalEvalSectionFrozen"
                      (closed)="marketActionSearchText=''" (click)="focusSearch('focus-market-action-search')"
                      (keydown.search)="focusSearch('focus-market-action-search')">
                      <input type="search" id="focus-market-action-search" class="dropdownsearchstyle"
                        [(ngModel)]="marketActionSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onMarketActionSelect($event,null)">Un-select</mat-option>
                      <mat-option *ngFor="let item of marketActionDropDown | assessmentSearch : marketActionSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onMarketActionSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-3" *ngIf="dynamicLabel['FINAL_COMPLAINT_CATEGORY']?.isRemovable != 'Y'">
                    <div>
                      <!-- Final Complaint Category -->
                      <label id="final-complaint-category-validation" for="final-complaint-category-validation">
                        {{dynamicLabel['FINAL_COMPLAINT_CATEGORY'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['FINAL_COMPLAINT_CATEGORY'].fieldNotes"
                        [matTooltip]="dynamicLabel['FINAL_COMPLAINT_CATEGORY'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput multiple placeholder="Select" #finalComplaintCategory
                      [(ngModel)]="qmsService.ccDropDowns.selectedFinalComplaintCategory"
                      (closed)="finalCategorySearchText=''" (click)="focusSearch('focus-final-category-search')"
                      (keydown.enter)="focusSearch('focus-final-category-search')"
                      [disabled]="isFinalEvalSectionFrozen">
                      <input type="search" id="focus-final-category-search" class="dropdownsearchstyle"
                        [(ngModel)]="finalCategorySearchText" matInput placeholder="search">
                      <div class="select-all">
                        <mat-checkbox [(ngModel)]="finalComplaintCategorySelection"
                          (change)="toggleAllSelection('finalComplaintCategory')">
                          Select All</mat-checkbox>
                      </div>
                      <mat-option
                        *ngFor="let item of reportedComplaintTypeDropDown | multiAssessmentSearchPipe : finalCategorySearchText"
                        [value]="item.valueExp" (onSelectionChange)="onFinalComplaintCategorySelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-3">
                    <div>
                      <!-- Final Company Complaint Type -->
                      <label id="final-complaint-type-validation" for="final-complaint-type">
                        {{dynamicLabel['FINAL_COMPANY_COMPLAINT_TYPE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['FINAL_COMPANY_COMPLAINT_TYPE'].fieldNotes"
                        [matTooltip]="dynamicLabel['FINAL_COMPANY_COMPLAINT_TYPE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select"
                      [ngClass]="{'odd-item-mat-select': oddFinalComplaintType == qmsService.ccDropDowns.selectedFinalCompanyComplaintType}"
                      [(ngModel)]="qmsService.ccDropDowns.selectedFinalCompanyComplaintType"
                      [disabled]="isFinalEvalSectionFrozen" (closed)="finalComplaintTypeSearchText=''"
                      (keydown.enter)="focusSearch('focus-final-complaint-search')"
                      (click)="focusSearch('focus-final-complaint-search')">
                      <input type="search" id="focus-final-complaint-search" class="dropdownsearchstyle"
                        [(ngModel)]="finalComplaintTypeSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onFinalComplaintTypeSelect($event,null)">Un-select</mat-option>
                      <mat-option
                        *ngFor="let item of finalCompanyComplaintTypeDropDown | assessmentSearch : finalComplaintTypeSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onFinalComplaintTypeSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-4" [hidden]="dynamicLabel['CLOSURE_COMMENTS'].isRemovable == 'Y'">
                    <div>
                      <!-- Closure Comments -->
                      <label id="closure-comments-validation" for="closure-comments">
                        {{dynamicLabel['CLOSURE_COMMENTS'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['CLOSURE_COMMENTS'].fieldNotes"
                        [matTooltip]="dynamicLabel['CLOSURE_COMMENTS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <div class="row">
                      <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qmsService.activity.closureComments" [config]="config"
                          [spellcheck]="true" [disabled]="isFinalEvalSectionFrozen"
                          (ngModelChange)="dynamicLabel['CLOSURE_COMMENTS'].isRemovable != 'Y' ? onStEditorChange($event, 'closure-comments-validation') : null"
                          (paste)="onPaste($event)"></st-editor>
                      </div>
                      <div class="col-sm-1 angular-editor-edit"
                        (keydown.enter)="isFinalEvalSectionFrozen ? openEditor('Closure Comments', 'eye') : openEditor('Closure Comments', 'edit')"
                        (click)="isFinalEvalSectionFrozen ? openEditor('Closure Comments', 'eye') : openEditor('Closure Comments', 'edit')">
                        <i *ngIf="!isFinalEvalSectionFrozen" class="far fa-edit"></i>
                        <i *ngIf="isFinalEvalSectionFrozen" class="fa fa-eye eye"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </mat-tab>
        </ng-container>

        <ng-container *ngIf="message.showReimbursementTab && tabPage === 'Reimbursement'">
          <mat-tab label="Reimbursement" [disabled]="!message.showReimbursementTab" *ngIf="tabPage=='Reimbursement'">
            <ng-template mat-tab-label>
              <span>
                <i class='fa fa-usd' style="font-size: 18px;" aria-hidden="true"></i>
              </span>&nbsp;
              <span>Reimbursement</span>
            </ng-template>
            <div class="form-template ActivityPage" style="margin-top:1%;">
              <fieldset class="border p-2 fieldsetStyle">
                <legend class="float-none w-auto p-2">
                  <span class="" style="font-size: 14px;color: #cfcfcf;">Reimbursement</span>
                </legend>
                <div class="row">
                  <div class="col-md-2">
                    <div>
                      <!-- Reimbursement Status -->
                      <label id="reimbursement-status-validation" for="reimbursement-status">
                        {{dynamicLabel['REIMBURSEMENT_STATUS'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSEMENT_STATUS'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSEMENT_STATUS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select"
                      [ngClass]="{'odd-item-mat-select': oddReimbursementStatus == qmsService.ccDropDowns.selectedReimbursementStatus}"
                      [(ngModel)]="qmsService.ccDropDowns.selectedReimbursementStatus"
                      [disabled]="isReimbursementSectionFrozen" (closed)="reimbursementStatusSearchText=''"
                      (click)="focusSearch('focus-reimbursement-status-search')"
                      (keydown.enter)="focusSearch('focus-reimbursement-status-search')">
                      <input type="search" id="focus-reimbursement-status-search" class="dropdownsearchstyle"
                        [(ngModel)]="reimbursementStatusSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onReimbursementStatusSelect($event,null)">Un-select</mat-option>
                      <mat-option
                        *ngFor="let item of reimbursementStatusDropDown | assessmentSearch : reimbursementStatusSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onReimbursementStatusSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-2" *ngIf="dynamicLabel['REIMBURSEMENT_TYPE']?.isRemovable != 'Y'">
                    <div>
                      <!-- Reimbursement Type -->
                      <label id="reimbursement-type-validation" for="reimbursement-type">
                        {{dynamicLabel['REIMBURSEMENT_TYPE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSEMENT_TYPE'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSEMENT_TYPE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select"
                      [ngClass]="{'odd-item-mat-select': oddReimbursementType == qmsService.ccDropDowns.selectedReimbursementType}"
                      [(ngModel)]="qmsService.ccDropDowns.selectedReimbursementType"
                      [disabled]="isReimbursementSectionFrozen" (closed)="reimbursementStatusSearchText=''"
                      (click)="focusSearch('focus-reimbursement-type-search')"
                      (keydown.enter)="focusSearch('focus-reimbursement-type-search')">
                      <input type="search" id="focus-reimbursement-type-search" class="dropdownsearchstyle"
                        [(ngModel)]="reimbursementStatusSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onReimbursementStatusSelect($event,null)">Un-select</mat-option>
                      <mat-option
                        *ngFor="let item of reimbursementTypeDropDown | assessmentSearch : reimbursementStatusSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onReimbursementStatusSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-4">
                    <div>
                      <!-- Reimbursement Tracking Details -->
                      <label id="" for="reimbursement-details">
                        {{dynamicLabel['REIMBURSEMENT_TRACKING_DETAILS'].fieldName}}
                      </label>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSEMENT_TRACKING_DETAILS'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSEMENT_TRACKING_DETAILS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                      [(ngModel)]="qmsService.activity.reimbursementTrackingDetails"
                      (ngModelChange)="onNgModelChange($event,'')" [disabled]="isReimbursementSectionFrozen"></textarea>
                  </div>
                  <div class="col-md-2" *ngIf="dynamicLabel['REIMBURSED_AMOUNT']?.isRemovable != 'Y'">
                    <div>
                      <!-- Amount -->
                      <label for="reimbursed-amount">{{dynamicLabel['REIMBURSED_AMOUNT'].fieldName}}</label>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSED_AMOUNT'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSED_AMOUNT'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <input class="input-filed-continers" type="number"
                      [(ngModel)]="qmsService.activity.reimbursedAmount" (keypress)="numberValidation($event)"
                      [disabled]="isReimbursementSectionFrozen">
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Requested Date -->
                      <label id="requested-date-validation" for="email">
                        {{dynamicLabel['REIMBURSEMNT_REQUESTED_DATE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSEMNT_REQUESTED_DATE'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSEMNT_REQUESTED_DATE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="qmsService.activity.reimbursemntRequestedDate"
                      (ngModelChange)="checkRequestDate($event,'requested-date-validation')"
                      [disabled]="isReimbursementSectionFrozen">
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Initiated Date -->
                      <label id="initiated-date-validation" for="initiated-date">
                        {{dynamicLabel['REIMBURSEMNT_INITIATED_DATE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['REIMBURSEMNT_INITIATED_DATE'].fieldNotes"
                        [matTooltip]="dynamicLabel['REIMBURSEMNT_INITIATED_DATE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="reimburseInitiatedDateConfig()" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="qmsService.activity.reimbursemntInitiatedDate"
                      (ngModelChange)="onNgModelChange($event,'initiated-date-validation')"
                      [disabled]="isReimbursementSectionFrozen || !qmsService.activity.reimbursemntRequestedDate">
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Attempts -->
                      <label for="attempts">{{dynamicLabel['ATTEMPTS'].fieldName}}</label>
                      <span class="info-icon" *ngIf="dynamicLabel['ATTEMPTS'].fieldNotes"
                        [matTooltip]="dynamicLabel['ATTEMPTS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <input class="input-filed-continers" type="number" [(ngModel)]="qmsService.activity.attempts"
                      (keypress)="numberValidation($event)" [disabled]="isReimbursementSectionFrozen">
                  </div>
                  <div class="col-md-4" [hidden]="dynamicLabel['REASON_FOR_NOSHOW'].isRemovable == 'Y'">
                    <div>
                      <!-- Reason for Noshow -->
                      <label for="reason-for-no-show">
                        {{dynamicLabel['REASON_FOR_NOSHOW'].fieldName}}
                      </label>
                      <span class="info-icon" *ngIf="dynamicLabel['REASON_FOR_NOSHOW'].fieldNotes"
                        [matTooltip]="dynamicLabel['REASON_FOR_NOSHOW'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <div class="row">
                      <textarea type="text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="qmsService.activity.reasonForNoshow"
                        [disabled]="isReimbursementSectionFrozen"></textarea>
                    </div>
                  </div>
                  <div class="col-md-4" [hidden]="dynamicLabel['RESOLUTION_COMMENTS'].isRemovable == 'Y'">
                    <div>
                      <!-- Resolution Comments -->
                      <label id="resolution-comments-validation" for="resolution-comments">
                        {{dynamicLabel['RESOLUTION_COMMENTS'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['RESOLUTION_COMMENTS'].fieldNotes"
                        [matTooltip]="dynamicLabel['RESOLUTION_COMMENTS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <div class="row">
                      <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qmsService.activity.resolutionComments"
                          (ngModelChange)="onNgModelChange($event,'resolution-comments-validation')" [config]="config"
                          [spellcheck]="true" [disabled]="isReimbursementSectionFrozen"
                          (paste)="onPaste($event)"></st-editor>
                      </div>
                      <div class="col-sm-1 angular-editor-edit"
                        (keydown.enter)="isReimbursementSectionFrozen ? openEditor('Resolution Comments', 'eye') : openEditor('Resolution Comments', 'edit')"
                        (click)="isReimbursementSectionFrozen ? openEditor('Resolution Comments', 'eye') : openEditor('Resolution Comments', 'edit')">
                        <i *ngIf="!isReimbursementSectionFrozen" class="far fa-edit"></i>
                        <i *ngIf="isReimbursementSectionFrozen" class="fa fa-eye eye"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </mat-tab>
        </ng-container>

        <ng-container *ngIf="message.showResponseTab && tabPage === 'Response'">
          <mat-tab label="Response">
            <ng-template mat-tab-label>
              <span>
                <i class='fa fa-reply' style="font-size: 18px;" aria-hidden="true"></i>
              </span>&nbsp;
              <span>Response</span>
            </ng-template>
            <div class="form-template ActivityPage" style="margin-top:1%;">
              <fieldset class="border p-2 fieldsetStyle">
                <legend class="float-none w-auto p-2">
                  <span class="" style="font-size: 14px;color: #cfcfcf;">Response</span>
                </legend>
                <div class="row">
                  <div class="col-md-2">
                    <div>
                      <!-- Response Status -->
                      <label id="response-status-validation" for="response-status">
                        {{dynamicLabel['RESPONSE_STATUS'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_STATUS'].fieldNotes"
                        [matTooltip]="dynamicLabel['RESPONSE_STATUS'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput placeholder="Select"
                      [ngClass]="{'odd-item-mat-select': oddResponseStatus == qmsService.ccDropDowns.selectedResponseStatus}"
                      [(ngModel)]="qmsService.ccDropDowns.selectedResponseStatus" [disabled]="isResponseSectionFrozen"
                      (closed)="responseStatusSearchText=''" (click)="focusSearch('focus-response-search')"
                      (keydown.enter)="focusSearch('focus-response-search')">
                      <input type="search" id="focus-response-search" class="dropdownsearchstyle"
                        [(ngModel)]="responseStatusSearchText" matInput placeholder="search">
                      <mat-option class="unselectStyle" [value]="null"
                        (onSelectionChange)="onResponseStatusSelect($event,null)">Un-select</mat-option>
                      <mat-option
                        *ngFor="let item of responseStatusDropDown | assessmentSearch : responseStatusSearchText"
                        [value]="item.valueExp" (onSelectionChange)="onResponseStatusSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Is Sample Returned? -->
                      <label for="sample-returned">
                        {{dynamicLabel['IS_SAMPLE_RETURNED'].fieldName}}
                      </label>
                      <span class="info-icon" *ngIf="dynamicLabel['IS_SAMPLE_RETURNED'].fieldNotes"
                        [matTooltip]="dynamicLabel['IS_SAMPLE_RETURNED'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-slide-toggle color="primary" [(ngModel)]="qmsService.activity.isSampleReturned"
                      [disabled]="isResponseSectionFrozen">
                      <ng-container *ngIf="qmsService.activity.isSampleReturned; else no">
                        <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
                      </ng-container>
                      <ng-template #no>
                        <span style="color: red;">No</span>
                      </ng-template>
                    </mat-slide-toggle>
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Method of Response -->
                      <label id="method-of-response-validation" for="method-of-response">
                        {{dynamicLabel['METHOD_OF_RESPONSE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['METHOD_OF_RESPONSE'].fieldNotes"
                        [matTooltip]="dynamicLabel['METHOD_OF_RESPONSE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <mat-select matInput multiple placeholder="Select" #methodOfResponse
                      [(ngModel)]="qmsService.ccDropDowns.selectedMethodOfResponse" [disabled]="isResponseSectionFrozen"
                      (closed)="methodOfResponseSearchText=''" (click)="focusSearch('focus-method-of-response-search')"
                      (keydown.enter)="focusSearch('focus-method-of-response-search')">
                      <input type="search" id="focus-method-of-response-search" class="dropdownsearchstyle"
                        [(ngModel)]="methodOfResponseSearchText" matInput placeholder="search">
                      <div class="select-all">
                        <mat-checkbox [(ngModel)]="methodOfResponseSelection"
                          (change)="toggleAllSelection('methodOfResponse')">
                          Select All</mat-checkbox>
                      </div>
                      <mat-option
                        *ngFor="let item of methodOfResponseDropDown | multiAssessmentSearchPipe : methodOfResponseSearchText"
                        [value]="item.valueExp" [ngClass]="{'missing-option': item.isMissing}"
                        (onSelectionChange)="onMethodOfResponseSelect($event,item)">
                        {{ item.displayExp }}
                      </mat-option>
                    </mat-select>
                  </div>
                  <div class="col-md-2">
                    <div>
                      <!-- Date of Response -->
                      <label id="date-of-response-validation" for="date-of-response">
                        {{dynamicLabel['DATE_OF_RESPONSE'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['DATE_OF_RESPONSE'].fieldNotes"
                        [matTooltip]="dynamicLabel['DATE_OF_RESPONSE'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <input type="text" class="form-control data-picker-continer" bsDatepicker
                      [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses"
                      [(ngModel)]="qmsService.activity.dateOfResponse"
                      (ngModelChange)="onNgModelChange($event,'date-of-response-validation')"
                      [disabled]="isResponseSectionFrozen">
                  </div>
                  <div class="col-md-4" [hidden]="dynamicLabel['RESPONSE_SUMMARY'].isRemovable == 'Y'">
                    <div>
                      <!-- Response Summary -->
                      <label id="response-summary-validation" for="response-summary">
                        {{dynamicLabel['RESPONSE_SUMMARY'].fieldName}}
                      </label> <span class="mandatory-symbol">*</span>
                      <span class="info-icon" *ngIf="dynamicLabel['RESPONSE_SUMMARY'].fieldNotes"
                        [matTooltip]="dynamicLabel['RESPONSE_SUMMARY'].fieldNotes">
                        <img [src]="infoIconSrc" alt="note" width="18" height="18">
                      </span>
                    </div>
                    <div class="row">
                      <div class="hideToolbar col-sm-11">
                        <st-editor [(ngModel)]="qmsService.activity.responseSummary"
                          (ngModelChange)="onNgModelChange($event,'response-summary-validation')" [config]="config"
                          [spellcheck]="true" [disabled]="isResponseSectionFrozen"
                          (paste)="onPaste($event)"></st-editor>
                      </div>
                      <div class="col-sm-1 angular-editor-edit"
                        (keydown.enter)="isResponseSectionFrozen ? openEditor('Response Summary', 'eye') : openEditor('Response Summary', 'edit')"
                        (click)="isResponseSectionFrozen ? openEditor('Response Summary', 'eye') : openEditor('Response Summary', 'edit')">
                        <i *ngIf="!isResponseSectionFrozen" class="far fa-edit"></i>
                        <i *ngIf="isResponseSectionFrozen" class="fa fa-eye eye"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </fieldset>
            </div>
          </mat-tab>
        </ng-container>

        <mat-tab label="Dependency" *ngIf="message.showDependancySection && tabPage=='Dependency'">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M13.05 7.36653L16.2 8.98115L8.99999 12.6717L1.79999 8.98115L5.00756 7.33702M13.05 10.8946L16.2 12.5092L8.99999 16.1998L1.79999 12.5092L5.00756 10.8651M8.99999 1.7998L16.2 5.49036L8.99999 9.18092L1.79999 5.49036L8.99999 1.7998Z"
                  stroke="#0F3659" [ngStyle]="{strokeWidth: selectedTab == 'Dependancy' ? '2' : ''}"
                  stroke-linecap="round" stroke-linejoin="round" />
              </svg>
            </span>&nbsp;
            <span>Dependency</span>
          </ng-template>
          <div class="form-template ActivityPage" id="Dependency" style="margin-top:1%;">
            <app-quality-dependencies *ngIf="selectedTab === 'Dependency'"></app-quality-dependencies>
          </div>
        </mat-tab>

        <mat-tab label="Notifications" *ngIf="tabPage=='Notifications'&& isAdditionalTabUser">
          <ng-template mat-tab-label>
            <span><i class="fa-solid fa-bell" style="font-size: 17px;"></i></span>&nbsp;
            <span>Notifications</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-activity-notifications *ngIf="selectedTab === 'Notifications'"></app-activity-notifications>
          </div>
        </mat-tab>

        <mat-tab label="History" *ngIf="tabPage=='History' && isAdditionalTabUser">
          <ng-template mat-tab-label>
            <span>
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M10.8875 10.7998L8.18755 9.8998V6.1365M15.3875 8.9998C15.3875 5.02335 12.164 1.7998 8.18755 1.7998C4.2111 1.7998 0.987549 5.02335 0.987549 8.9998C0.987549 12.9763 4.2111 16.1998 8.18755 16.1998C10.8526 16.1998 13.1794 14.7519 14.4243 12.5998M13.4124 8.20968L15.2124 10.0097L17.0124 8.20968"
                  stroke="#0F3659" stroke-linecap="round" stroke-linejoin="round"
                  [ngStyle]="{strokeWidth: selectedTab == 'History' ? '2' : ''}" />
              </svg>
            </span>&nbsp;
            <span>History</span>
          </ng-template>
          <div class="form-template ActivityPage" style="margin-top:1%;">
            <app-task-history *ngIf="selectedTab === 'History'"></app-task-history>
          </div>
        </mat-tab>
      </div>
    </mat-tab-group>
  </div>
</div>

<ng-template #editor>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelEditor()" mat-button><i class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ this.editorTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div><br>
  <div class="row">
    <div class="col-md-12 st-editor">
      <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? config1 : config" [spellcheck]="true"
        (paste)="onPaste($event)"></st-editor>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
      <i class="fas fa-check"></i> Save
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelTopicPopup()">
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{qmsService.moduleFullName}}&nbsp;Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>

<ng-template #mandatoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>

  <button class="close close-button" (click)="closeMandatoryPopup()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Mandatory Alert </label>
  </div>

  <div style="margin: 15px 15px;">
    <div style="display: flex; justify-content: center; align-items: center;">
      <span style="font-weight: 500; font-size: larger;"> Please enter all Mandatory Fields
        <span style="color: red; font-size: x-large;"><i class="fa-solid fa-exclamation"></i></span>
        <br>
        <span style="font-size: .8rem; font-weight:500;"
          *ngIf="isFinalEvaluationFailed || isReimbursementFailed || isResponseFailed">
          ( Tabs including {{ getFailedTabs() }} )
        </span>
      </span>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="cancelButton" (click)="closeMandatoryPopup()">
        Ok
      </button>
    </div>
  </div>
</ng-template>

<ng-template #taskActionHistoryPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelTaskActionHistoryPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Task Actions History </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-task-actions-history></app-task-actions-history>
</ng-template>

<ng-template #openExportReportPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" mat-button (click)="cancelExportPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Choose Report Template </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="form-continer1">
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label id="reportTemplate-validation" for="email">Report Template</label>
        <span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportTemplateValue"
          (closed)="pdfDetailSearchText=''" (keydown.enter)="focusSearch('focus-Template-search')"
          (click)="focusSearch('focus-Template-search')">

          <input type="search" id="focus-Template-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportTemplateRemoved($event)">Un-select</mat-option>

          <mat-option *ngFor="let item of reportTemplateDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportTemplateSelect($event, item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <br>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Report Logo</label>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportLogoValue"
          (keydown.enter)="focusSearch('focus-Logo-search')" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-Logo-search')">
          <input type="search" id="focus-Logo-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle"
            (onSelectionChange)="onReportLogoValueSelect($event,null);">Un-select</mat-option>
          <mat-option *ngFor="let item of reportLogoDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportLogoValueSelect($event,item)" [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Select Footer</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <mat-select matInput placeholder="Select" [(ngModel)]="selectedReportFooter"
          (keydown.enter)="focusSearch('focus-footer-search')" (closed)="pdfDetailSearchText=''"
          (click)="focusSearch('focus-footer-search')">
          <input type="search" id="focus-footer-search" class="dropdownsearchstyle" [(ngModel)]="pdfDetailSearchText"
            matInput placeholder="search">

          <mat-option *ngFor="let item of reportFooterDropdown | assessmentSearch : pdfDetailSearchText"
            (onSelectionChange)="onReportFooterSelect($event,item)" [value]="item.displayExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Is Save Report?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="isSaveReport">
          <ng-container *ngIf="isSaveReport; else noisSaveReport">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noisSaveReport>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="isSaveReport">
      <div class="col-sm-4">
        <label for="email">Report Name</label><span class="mandatory-symbol">*</span>
      </div>
      <div class="col-sm-8">
        <input type="text" class="input-filed-continers" [(ngModel)]="reportName">
      </div>
    </div>

    <div class="row justify-content-md-center">
      <div class="col-sm-4">
        <label for="email">Attach all documents?</label>
      </div>
      <div class="col-sm-8">
        <mat-slide-toggle color="primary" name="reportEnabled" [(ngModel)]="attachAllDocuments">
          <ng-container *ngIf="attachAllDocuments; else noattachAllDocuments">
            <span class="active-inActive-container" style="color: rgb(43, 227, 43);">Yes</span>
          </ng-container>
          <ng-template #noattachAllDocuments>
            <span style="color: red;">No</span>
          </ng-template>
        </mat-slide-toggle>
      </div>
    </div>
    <div class="row justify-content-md-center" *ngIf="attachAllDocuments">

      <label for="email">Attachments to the report are limited to PDF, DOC, or DOCX formats.</label>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="exportReport()">
      <i class="fas fa-check"></i> Generate
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelReport()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-add-parallel-workflows (valueEmitter)="onWorkflowChildValueEmitted()"
  *ngIf="addWorkflow"></app-add-parallel-workflows>
<app-homepagetag #tagRecordPopup (valueEmitter)="onTagChildValueEmitted()"></app-homepagetag>
<app-quality-dependents></app-quality-dependents>
